import React from "react";
import { useTranslation } from "react-i18next";
// Redux
import { useSelector } from "react-redux";
// Constants
import { pathHomePage } from "../../config/constants";
//Components
import { FooterContainer, AddPatientContainer } from "./styles";
import ButtonWithIcon from "../buttonWithIcon";
// Assets
import AddPatient from "../../assets/ico_add_patient.svg";

const Footer = () => {
  const clinicianData = useSelector(({ clinician }) => clinician.data);
  const [t] = useTranslation("global");

  return (
    <FooterContainer>
      {clinicianData.CLINICIAN_USER !== "Artem" && (
        <AddPatientContainer>
          <ButtonWithIcon
            icon={AddPatient}
            name={t("home.newPatientButton")}
            path={`${pathHomePage}/add-patient/${clinicianData.token}`}
          />
        </AddPatientContainer>
      )}
    </FooterContainer>
  );
};

export default Footer;
